import axios from 'axios'
import utils from '@/plugins/utils'
import qs from 'qs'

const SLOT_API = '/slots/'
const DRAFT_SLOT_API = '/draft-slots/'
const CLASS_API = '/classes/'
const BUS_API = '/buses/'
const BUS_STOP_API = '/bus-stops/'
const BUS_CHECKIN = '/bus-trackings/'
const BUS_STUDENT_CHECKIN = 'bus-student-trackings/'
const BUS_STUDENT = '/bus-students/'
const BUS_SCHEDULES = '/bus-schedules/'
const STUDENT_API = '/students/'
const ATTENDANCE_API = '/attendances/'
const LOG_API = '/Logs/'
const MAJOR_API = '/Majors/'
const SCHOOL_YEAR_API = '/SchoolYears/'
const UPLOAD_API = '/upload/'
const DESTROY_API = '/upload/files/'
const COURSE_API = '/courses/'
const LESSON_API = '/lessons/'
const STAFF_API = '/staff/'
const TEACHER_API = '/teachers/'
const TEACHING_API = '/teachings/'
const ACADEMIC_PERIOD_API = '/academic-periods/'

// Teacher doc and docCat api
const TEACHERCAT_API = '/teacher-doc-categories/'
const TEACHERDOC_API = '/teacher-documents/'
const USER_API = '/users/'
const BILL_API = '/bills/'
const PRODUCT_API = '/products/'
const AUTH_API = '/auth/local'
const MARK_API = '/marks/'
const TRANSCRIPT_API = '/transcripts/'
const FACILITY_API = '/facilities/'
const LIBRARY_API = '/facilities/'
const ROOM_API = '/rooms/'
const DIVISION_API = '/divisions/'
const SEMESTER_API = '/semesters/'
const GRADE_API = '/grades/'
const SUBJECT_API = '/subjects/'
const VIOLATION_API = '/violations/'
const FACTOR_API = '/factors/'
const POST_API = '/posts/'
const SUBJECT_GROUP_API = '/subject-groups/'
const CONTACT_BOOK_API = '/contact-books/'
const SMS_API = '/sms/'
const HISTORY_API = '/histories/'
const ACADEMIC_LEVEL_API = '/academic-levels/'
const DILIGENCE_API = '/diligences/'
const CHECKIN_API = '/checkins/'
const MESSAGE_API = '/messages/'
const MESSAGE_GROUP_API = '/message-groups/'
const DOCUMENT_TYPE_API = '/document-types/'
const DOCUMENT_API = '/documents/'
const CLASSNOTE_API = '/class-notes/'
const DISH_API = '/dishes/'
const MENU_API = '/menus/'
const STUDENT_MENU_API = '/student-menus/'
const MEAL_TRANSFER_API = '/meal-transfers/'

const TUITION_FEE_GROUP_API = '/tuition-fee-groups/'
const TUITION_FEE_HEAD_FEE_API = '/tuition-fee-head-fees/'
const TUITION_FEE_GROUP_STUDENT_API = '/tuition-fee-group-students/'
const TUITION_FEE_GROUP_HEAD_FEE_API = '/tuition-fee-group-head-fees/'
const TUITION_FEE_FRICE_API = '/tuition-fee-prices/'
const TUITION_FEE_PRICE_STUDENT_API = '/tuition-fee-price-students/'
const TUITION_FEE_PERIOD = '/tuition-fee-periods/'
const BANK_ACCOUNT_API = '/tuition-fee-bank-accounts/'
const TUITION_FEE_REPORT = '/tuition-fee-reports/'
const TUITION_FEE_COLLECTION = '/tuition-fee-collections/'
const TASK_PROGRESS = '/task-progresses/'
const STUDENT_TRACKING = '/bus-student-trackings/'
const ROLE_API = '/users-permissions/roles/'
const POLICIES_API = '/policies/'
const TASK_API = '/tasks/'

const SALARY_COLLECTION_API = '/salary-collections/'
const SALARY_PERIOD_API = '/salary-periods/'
const SALARY_HEAD_API = '/salary-heads/'
const SALARY_GROUP_API = '/salary-groups/'
const SALARY_GROUP_TEACHER_API = '/salary-group-teachers/'
const SALARY_GROUP_HEAD_API = '/salary-group-heads/'
const SALARY_PRICE_API = '/salary-prices/'
const SALARY_PRICE_TEACHER_API = '/salary-price-teachers/'
const SALARY_REPORT_API = '/salary-reports/'
const SBSENT_REQUEST_API = '/absent-requests/'
const DOC_CATEGORY_API = '/doc-categories-academic'
const GRADE_DOCUMENT_API = '/grade-documents/'
const LESSON_ATTENDANCE_API = '/lesson-attendances/'

// Single types
const USER_META_API = '/user-meta/'
const SCHOOL_SETTINGS_API = '/school-settings/'

// Student credit
const STUDENT_CREDIT = '/student-credits/'
const STUDENT_CREDIT_USAGE = '/student-credit-usages/'
// Exams
const EXAM_API = '/exams/'
const SUBJECT_EXAM_API = '/subject-exams/'
const SUBJECT_EXAM_GROUP_API = '/subject-exam-groups/'
const STUDENT_EXAM_API = '/student-exams/'
const EXAM_ROOM_API = '/exam-rooms/'
const INDEXING_API = '/indexing-progresses/'
const EXAM_MARK_API = '/exam-marks/'
const ROOM_SUBJECT_API = '/room-subjects/'
const TEACHER_EXAM_API = '/teacher-exams/'
const MONITOR_EXAM_API = '/monitor-exams/'
const GRADE_REVIEW_API = '/grade-review-forms/'

const CLASSROOM_API = '/classrooms/'
const CATEGORY_API = '/categories/'
const BOOK_API = '/books/'
const PROJECT_TOPIC_API = '/project-topics/'
const PROJECT_WISH_API = '/project-wishes/'
const PROJECT_COUNCIL_API = '/project-councils/'
const RESEARCH_TOPIC_API = '/research-topics/'
const RESEARCH_COUNCIL_API = '/research-councils/'

// Grade-mark
const GRADE_MARK_API = '/grade-marks/'
const GRADE_CLASS_MARK_API = '/grade-class-marks/'
const GRADE_CLASS_MARK_STUDENT_API = '/grade-class-mark-students/'
const Order_API = '/orders/'
const ORDER_CHECK_API = '/order-checks/'

//tool
const TOOL_API = '/tools/'

const EVALUATE_API = '/evaluates/'
const EVALUATE_CRITERIA_API = '/evaluate-criteria/'
const EVALUATE_STUDENT_API = '/evaluate-students/'
const EVALUATE_TEMPLATE_API = '/evaluate-templates/'
const DEPARTMENT_API = '/departments/'

// CRM
const APPOINTMENT_API = '/appointments/'
const LEAD_API = '/leads/'
const LEAD_LOG_API = '/lead-logs/'
const LEAD_PROGRESS_API = '/lead-progresses/'
const SALE_PRODUCT_API = '/sale-products/'
const PRODUCT_TYPE_API = '/product-types/'
const STATUS_COUNT = '/countStatus/'
const SUCCEED_COUNT = '/countSucceed/'
const TUITION_FEE_CLASS_SETTINGS_API = '/tuition-fee-class-settings/'

const APIHelper = (api) => ({
  search: (params, option) => axios.get(api, { params: utils.filterObject(params) }, option),
  count: (params, option) => axios.get(api + 'count', { params: utils.filterObject(params) }, option),
  fetch: (params, option) => axios.get(api, { params: utils.filterObject(params) }, option),
  fetchOne: (id, option) => axios.get(api + id, option),
  create: (params, options) => axios.post(api, utils.filterObject(params), options),
  checkin: (params, options) => axios.post(api + 'checkin', utils.filterObject(params), options),
  update: (id, params, option) => axios.put(api + id, params, option),
  remove: (id, option) => axios.delete(api + id, option),

  // query string
  qsFetch: (params) => {
    const query = qs.stringify(utils.filterObject(params))
    return axios.get(`${api}?${query}`)
  },
  qsCount: (params) => {
    const query = qs.stringify(utils.filterObject(params))
    return axios.get(`${api}count?${query}`)
  },
})
export const APIRespository = APIHelper
export const Auth = {
  ...APIHelper(AUTH_API),
  signIn: (params, options) => axios.post('/auth/log-in', utils.filterObject(params), options),
  forgotPassword: (email) => axios.post('/auth/forgot-password', { email }),
  resetPassword: (code, password, passwordConfirmation) =>
    axios.post('/auth/reset-password', {
      code,
      password,
      passwordConfirmation,
    }),
}
export const Role = {
  ...APIHelper(ROLE_API),
  updateRole: (id, params) => axios.put('/users-permissions/updateRole/' + id, params),
}
export const Policies = {
  ...APIHelper(POLICIES_API),
  checkAuthPolices: (id) => axios.get('/checkAuthPolices/' + id),
}
export const Class = {
  ...APIHelper(CLASS_API),
  getSimpleClasses: (params) => axios.get('/getSimpleClasses', { params: utils.filterObject(params) }),
  getClassWithGrade: (params) => axios.get('/getClassWithGrade', { params: utils.filterObject(params) }),
  updateLesson: (params, options) => axios.post('/classes/time-table', utils.filterObject(params), options),
}
export const Bus = APIHelper(BUS_API)
export const BusStudent = {
  ...APIHelper(BUS_STUDENT),
  busStudentReport: (params, option) =>
    axios.get('/bus-students-report', { params: utils.filterObject(params) }, option),
}
export const BusSchedules = APIHelper(BUS_SCHEDULES)
export const BusStop = {
  ...APIHelper(BUS_STOP_API),
  addStudentInBusStop: (id, params, option) => axios.put(`/add-student-in-bus-stop/${id}`, params, option),
  addStudentInBusStopInAllDay: (id, params, option) =>
    axios.put(`/add-student-in-all-day-bus-stop/${id}`, params, option),
  addStudentInBusStops: (params, options) =>
    axios.post(`/add-student-in-bus-stops`, utils.filterObject(params), options),
  deleteStudentInBusStop: (id, params, option) => axios.put(`/delete-student-in-bus-stop/${id}`, params, option),
  addBusStopInAllDay: (params, options) => axios.post(`/add-bus-stop-in-all-day`, utils.filterObject(params), options),
  updateBusStopOrder: (params) => axios.post('/update-bus-stop-order', params),
}
export const Student = {
  ...APIHelper(STUDENT_API),
  getOnlineCourses: (params) => axios.get('/getOnlineCourses', { params }),
  changeStudentClass: (params) => axios.post('/changeStudentClass', utils.filterObject(params)),
  getBasicStudentData: (params) => axios.get('/getBasicStudentData', { params }),
}
export const Attendance = {
  ...APIHelper(ATTENDANCE_API),
  getAttendanceStudents: (params) => axios.get('/getAttendanceStudents', { params: utils.filterObject(params) }),
}
export const BusCheckin = {
  ...APIHelper(BUS_CHECKIN),
  // getBusCheckins: params => axios.get('/bus-trackings', { params: utils.filterObject(params) }),
  updateBusCheckinStatus: (params) => axios.post('/bus-trackings', utils.filterObject(params)),
  getBusSchedule: (params) => axios.get('/bus-schedules', { params: utils.filterObject(params) }),
  getBusStudentTrackings: (params) => axios.get('/bus-student-trackings', { params: utils.filterObject(params) }),
}
export const BusStudentCheckin = {
  ...APIHelper(BUS_STUDENT_CHECKIN),
  updateStatusAndTimeBusStudentTracking: (id, params) =>
    axios.post('/bus-student-trackings/update-status-and-time/' + id, utils.filterObject(params)),
}
export const Slot = APIHelper(SLOT_API)
export const DraftSlot = APIHelper(DRAFT_SLOT_API)
export const Log = APIHelper(LOG_API)
export const Evaluate = {
  ...APIHelper(EVALUATE_API),
  generateEvaluate: (params) => axios.post('/evaluates/generate-evaluate', utils.filterObject(params)),
  statisticEvaluate: (params) => axios.post('/evaluates/statistic', utils.filterObject(params)),
}
export const EvaluateCriteria = APIHelper(EVALUATE_CRITERIA_API)
export const EvaluateTemplate = APIHelper(EVALUATE_TEMPLATE_API)
export const EvaluateStudent = {
  ...APIHelper(EVALUATE_STUDENT_API),
  createOrUpdate: (params) => axios.post('/evaluate-students/insert', utils.filterObject(params)),
}
export const Department = APIHelper(DEPARTMENT_API)
export const Major = APIHelper(MAJOR_API)
export const SchoolYear = APIHelper(SCHOOL_YEAR_API)
export const Course = APIHelper(COURSE_API)
export const Lesson = {
  ...APIHelper(LESSON_API),
  updateTeachers: (id, params) => axios.put(`/lessons/${id}/update-teachers`, params),
  updateAttendance: (id, params) => axios.put('/lessons/take-attendance/' + id, { ...params }),
  findTimeTable: (params, options) => axios.post('/lessons/find-time-table', utils.filterObject(params), options),
}
export const Staff = {
  ...APIHelper(STAFF_API),
  updatePasswordStaff: (params) => axios.post('/update-password-staff', params),
}
export const Teacher = APIHelper(TEACHER_API)
export const User = APIHelper(USER_API)
export const UserMeta = {
  ...APIHelper(USER_META_API),
  updateIndexUser: (params) => axios.post('/updateIndexUser', params),
  changePassword: (params) => axios.post('/changePassword', { params }),
}
export const SchoolSettings = {
  ...APIHelper(SCHOOL_SETTINGS_API),
  update: (params) => axios.put(SCHOOL_SETTINGS_API, params),
}
export const Bill = APIHelper(BILL_API)
export const Product = APIHelper(PRODUCT_API)
export const Mark = APIHelper(MARK_API)
export const Facility = APIHelper(FACILITY_API)
export const Book = APIHelper(LIBRARY_API)
export const Transcript = APIHelper(TRANSCRIPT_API)
export const Category = APIHelper(CATEGORY_API)
export const Division = {
  ...APIHelper(DIVISION_API),
  fetchDivisionsWithAcademicLevel: (params) => axios.get(`/get-divisions-with-academic`, { ...params }),
}
export const Grade = APIHelper(GRADE_API)
export const Semester = APIHelper(SEMESTER_API)
export const Subject = APIHelper(SUBJECT_API)
export const Violation = APIHelper(VIOLATION_API)
export const Factor = APIHelper(FACTOR_API)
export const Post = APIHelper(POST_API)
export const SubjectGroup = APIHelper(SUBJECT_GROUP_API)
export const ContactBook = {
  ...APIHelper(CONTACT_BOOK_API),
  resend: (historyId) => axios.post('/contact-books/resend', { historyId }),
  updateContact: (id, params) => axios.put('/contact-books/' + id, params),
  sendDailyViolation: (params) => axios.post('/contact-books/sendDailyViolation', params),
  sendMarkNotification: (params) => axios.post('/contact-books/sendMarkNotificationDaily', params),
  sendDiligence: (params) => axios.post('/contact-books/sendDiligence', utils.filterObject(params)),
  sendTuitionFeePeriodNoti: (params) =>
    axios.post('/contact-books/sendTuitionFeePeriodNoti', utils.filterObject(params)),
  sendTuitionFeePeriod: (params) => axios.post('/send-message-histories', utils.filterObject(params)),
  getProgressTuitionFeePeriod: (params) => axios.get('/send-message-histories', { params: utils.filterObject(params) }),
}
export const Teaching = {
  ...APIHelper(TEACHING_API),
  countTeaching: (params, option) => axios.get(TEACHING_API + 'count', { params }, option),
  searchTeaching: (params, option) => axios.get(TEACHING_API, { params }, option),
}
export const TeacherCat = {
  ...APIHelper(TEACHERCAT_API),
  fetchTree: (level, type, id = '', params, option) =>
    axios.get(TEACHERCAT_API + `${type}/` + `${level}/` + id, { params }, option),
}
export const DocCategory = {
  ...APIHelper(DOC_CATEGORY_API),
  fetchTree: (params) => axios.get(`/doc-categories-academic`, { params }),
}
export const TeacherDoc = {
  ...APIHelper(TEACHERDOC_API),
  count: (params, option) => axios.get(TEACHERDOC_API + 'count', { params }, option),
}
export const Sms = APIHelper(SMS_API)
export const History = APIHelper(HISTORY_API)
export const AcademicLevel = {
  ...APIHelper(ACADEMIC_LEVEL_API),
  fetchAcademicLevel: (params) => axios.get('/academic-levels/find-academics', { params }),
  updateAcademicLevel: (data) => axios.post('/academic-levels/update-academics', data),
}
export const Diligence = {
  ...APIHelper(DILIGENCE_API),
  getStudentDiligences: (params) => axios.get('/getStudentDiligences', { params: utils.filterObject(params) }),
}
export const Checkin = APIHelper(CHECKIN_API)
export const Message = APIHelper(MESSAGE_API)
export const MessageGroup = APIHelper(MESSAGE_GROUP_API)
export const DocumentType = APIHelper(DOCUMENT_TYPE_API)
export const Document = APIHelper(DOCUMENT_API)
export const ClassNote = {
  ...APIHelper(CLASSNOTE_API),
  fetchReportByTeacher: (params, option) => axios.get('/fetchReportByTeacher', { params }, option),
}
export const Dish = APIHelper(DISH_API)
export const Menu = APIHelper(MENU_API)
export const MealTransfer = APIHelper(MEAL_TRANSFER_API)
export const StudentMenu = {
  ...APIHelper(STUDENT_MENU_API),
  getMenuRegisterByStudents: (params) =>
    axios.get('/getMenuRegisterByStudents', { params: utils.filterObject(params) }),
  getStudentMealReportByMonth: (params) =>
    axios.get('/getStudentMealReportByMonth', { params: utils.filterObject(params) }),
  getStudentMealReportByDate: (params) =>
    axios.get('/getStudentMealReportByDate', { params: utils.filterObject(params) }),
  getStudentMenuCountReportByWeek: (params) => axios.get('/getStudentMenuCountReportByWeek', { params }),
}

export const TuitionFeeHeadFee = APIHelper(TUITION_FEE_HEAD_FEE_API)
export const TuitionFeeGroupStudent = APIHelper(TUITION_FEE_GROUP_STUDENT_API)
export const BankAccount = {
  ...APIHelper(BANK_ACCOUNT_API),
  findTuitionBankAccounts: (params) => axios.get('/findTuitionBankAccounts', { params }),
}
export const TuitionFeeReport = {
  ...APIHelper(TUITION_FEE_REPORT),
  summary: (params, option) => axios.post('/tuition-fee-reports/generate', { ...params }, option),
  statisticSumHeadFee: (id, params, option) =>
    axios.get(`/tuition-fee-reports/statistic-sum-head-fee/${id}`, { params: utils.filterObject(params) }, option),
  statisticHeadFee: (id, params, option) => {
    return axios.get(`/tuition-fee-reports/statistic-head-fee/${id}`, { params: utils.filterObject(params) }, option)
  },
}

export const TuitionFeeGroupHeadFee = {
  ...APIHelper(TUITION_FEE_GROUP_HEAD_FEE_API),
  createPrice: (params, options) =>
    axios.post('/tuition-fee-group-head-fees/create-price', utils.filterObject(params), options),
  removePrice: (id, params, option) => axios.put('/tuition-fee-group-head-fees/delete-price/' + id, params, option),
}
export const tuitionFeePriceStudent = {
  ...APIHelper(TUITION_FEE_PRICE_STUDENT_API),
  addPack: (params, options) =>
    axios.post('/tuition-fee-price-students/add-pack/', utils.filterObject(params), options),
  removePriceStudent: (id, option) => axios.delete('/tuition-fee-price-students/remove-all-student/' + id, option),
}
export const TuitionFeeGroup = {
  ...APIHelper(TUITION_FEE_GROUP_API),
  removeStudent: (id, option) => axios.delete('tuition-fee-groups/remove-students/' + id, option),
  addStudentPack: (params, option) => axios.post('tuition-fee-group-students/add-student-pack', { ...params }, option),
  fetchTuitionFeeGroup: (params) => axios.get('fetchTuitionFeeGroup', { params }),
}
export const TuitionFeePrice = APIHelper(TUITION_FEE_FRICE_API)
export const TuitionFeeCollection = APIHelper(TUITION_FEE_COLLECTION)
export const TuitionFeePeriod = {
  ...APIHelper(TUITION_FEE_PERIOD),
  totalFee: (params, option) => axios.get('/tuition-fee-periods/caculate-total-fee', { params: params }, option),
}
export const Upload = {
  upload: (formData) =>
    axios.post(UPLOAD_API, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }),
  destroy: (id) => axios.delete(DESTROY_API + id),
}
export const StudentTracking = APIHelper(STUDENT_TRACKING)
export const TaskProgress = {
  ...APIHelper(TASK_PROGRESS),
  uploadAvatar: (formData) =>
    axios.post('/task-progresses/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }),
}
export const Task = {
  ...APIHelper(TASK_API),
  createTasks: (params) => axios.post('/createTasks', utils.filterObject(params)),
}
export const SalaryPeriod = {
  ...APIHelper(SALARY_PERIOD_API),
  getTotalFee: (params, option) => axios.get('/salary-periods/cal-total', { params: params }, option),
}
export const SalaryCollection = APIHelper(SALARY_COLLECTION_API)
export const SalaryHead = APIHelper(SALARY_HEAD_API)
export const SalaryGroup = {
  ...APIHelper(SALARY_GROUP_API),
  fetchSalaryGroup: (params) => axios.get('/fetch-salary-groups', { params }),
  removeTeacher: (id, option) => axios.delete('/salary-groups/remove-teacher/' + id, option),
  addTeacherPack: (params, option) => axios.post('/salary-group-teachers/add-teacher-pack', { ...params }, option),
}
export const SalaryGroupHead = {
  ...APIHelper(SALARY_GROUP_HEAD_API),
  createPrice: (params, options) => axios.post('/salary-group-heads/create-price', utils.filterObject(params), options),
  removePrice: (id, params, option) => axios.put('/salary-group-heads/delete-price/' + id, params, option),
}
export const SalaryGroupTeacher = APIHelper(SALARY_GROUP_TEACHER_API)
export const SalaryPrice = APIHelper(SALARY_PRICE_API)
export const SalaryPriceTeacher = {
  ...APIHelper(SALARY_PRICE_TEACHER_API),
  addPack: (params, options) => axios.post('/salary-price-teachers/add-pack/', utils.filterObject(params), options),
  removePriceTeacher: (id, option) => axios.delete('/salary-price-teachers/remove-all-teachers/' + id, option),
}
export const SalaryReport = {
  ...APIHelper(SALARY_REPORT_API),
  summary: (params, option) => axios.post('/salary-reports/generate', { ...params }, option),
  statisticSumHeadFee: (id, params, option) =>
    axios.get(`/salary-reports/statistic-sum-head-fee/${id}`, { params: utils.filterObject(params) }, option),
  statisticHeadFee: (id, params, option) => {
    return axios.get(`/salary-reports/statistic-head-fee/${id}`, { params: utils.filterObject(params) }, option)
  },
}
export const SbsentRequest = {
  ...APIHelper(SBSENT_REQUEST_API),
}

export const StudentCreditApi = {
  ...APIHelper(STUDENT_CREDIT),
  requestCharge: (params, option) => axios.post('/student-credits/request-recharge', { ...params, option }),
  getBalance: (params) => axios.get('/student-info-balance', { ...params }),
  fetchByStudent: (params) => axios.get('/student-credits/find-by-student', { ...params }),
  countByStudent: (params) => axios.get('/student-credits/count-by-student', { ...params }),
  studentCreditReport: (params) => axios.get('/student-credits/report-credit-usage', { ...params }),
}

export const StudentCreditUsageApi = {
  ...APIHelper(STUDENT_CREDIT_USAGE),
}

export const GradeDocument = {
  ...APIHelper(GRADE_DOCUMENT_API),
}
export const LessonAttendance = {
  ...APIHelper(LESSON_ATTENDANCE_API),
  findStatsAttendance: (params) => axios.get('/lesson-attendances/find-stats', { params }),
}

// Exams
export const Exam = {
  ...APIHelper(EXAM_API),
}
export const SubjectExam = {
  ...APIHelper(SUBJECT_EXAM_API),
}
export const SubjectExamGroup = {
  ...APIHelper(SUBJECT_EXAM_GROUP_API),
  updateMany: (data) => axios.put('/updateManyGroups', { ...data }),
}
export const Room = {
  ...APIHelper(ROOM_API),
  createManyRooms: (data) => {
    return axios.post(`/rooms/createMany`, { ...data })
  },
  excelRooms: (data) => {
    return axios.post('/rooms/excelRooms', { ...data })
  },
}
export const StudentExam = {
  ...APIHelper(STUDENT_EXAM_API),
  createAllMainExam: (data) => {
    return axios.post(`/createAllMainExam`, { ...data })
  },
  assignSubjectGroupAll: (data) => {
    return axios.post(`/assignSubjectGroupAll`, { ...data })
  },
  studentFromCode: (params) => {
    return axios.get(`/studentFromCv`, { params: utils.filterObject(params) })
  },
  assignRooms: (data) => {
    return axios.post('/assignRooms', { ...data })
  },
  indexingStudent: (data) => axios.put(`/indexingStudent`, { ...data }),
  indexingEmpty: (data) => axios.put(`/indexingEmpty`, { ...data }),
  autoAssignRooms: (data) => axios.put(`/autoAssignRooms`, { ...data }),
}
export const ExamRoom = {
  ...APIHelper(EXAM_ROOM_API),
}
export const Indexing = {
  ...APIHelper(INDEXING_API),
}
export const ExamMark = {
  ...APIHelper(EXAM_MARK_API),
  updateGrades: (data) => axios.put(`/updateGrades`, { ...data }),
  updateStatus: (data) => axios.put('/updateStatus', { ...data }),
  getMarksData: (params) => {
    return axios.get(`/getMarksData`, { params: utils.filterObject(params) })
  },
  getMarksExcel: (params) => {
    return axios.get(`/getMarksExcel`, { params: utils.filterObject(params) })
  },
}
export const RoomSubject = {
  ...APIHelper(ROOM_SUBJECT_API),
  assignTestCode: (data) => axios.put(`/assignTestCode`, { ...data }),
  assignRoomCode: (data) => axios.put(`/assignRoomCode`, { ...data }),
  assignDate: (data) => axios.put('/assignDate', { ...data }),
}
export const TeacherExam = {
  ...APIHelper(TEACHER_EXAM_API),
}
export const MonitorExam = {
  ...APIHelper(MONITOR_EXAM_API),
}
export const GradeReview = {
  ...APIHelper(GRADE_REVIEW_API),
}
export const Classroom = {
  ...APIHelper(CLASSROOM_API),
}
export const BookApi = {
  ...APIHelper(BOOK_API),
  reportLostBook: (id, data) => axios.put(`/order-books/lost-book/${id}`, { ...data }),
  reportDetailBook: (id) => axios.get(`/books/report-detail-book/${id}`),
  fetchBookHistory: (params) => axios.get(`/book-histories`, { params }),
}
export const OrderApi = {
  ...APIHelper(Order_API),
  payment: (data) => axios.post('/orders/payment', { ...data }),
  updateOrderPayment: (data) => axios.post('/orders/create-by-app', { ...data }),
  fetchWithProduct: (id, params) => axios.get(`/orders/${id}`, { params }),
  getLibraryOrder: (params) => axios.get('/get-library-orders', { params: utils.filterObject(params) }),
  completeOrder: (id) => axios.post(`/orders/complete-order/${id}`),
  completePartialBookOrder: (data) => axios.post('/complete-patial-book', { ...data }),
}
export const GradeMarkApi = {
  ...APIHelper(GRADE_MARK_API),
  createMany: (data) => axios.post('/grade-marks/create-many', data),
  deParent: (data) => axios.post('/grade-marks/de-parent', data),
}
export const GradeClassMarkApi = {
  ...APIHelper(GRADE_CLASS_MARK_API),
}
export const GradeClassMarkStudentApi = {
  ...APIHelper(GRADE_CLASS_MARK_STUDENT_API),
  createMany: (data) => axios.post('/grade-class-mark-students/create-many', data),
  updateMany: (data) => axios.post('/grade-class-mark-students/update-many', data),
  getStudentMarks: (params) => axios.get('/get-student-marks', { params }),
  countStudentMarks: (params) => axios.get('/count-student-marks', { params }),
}
export const ProjectTopic = { ...APIHelper(PROJECT_TOPIC_API) }
export const ProjectWish = { ...APIHelper(PROJECT_WISH_API) }
export const ProjectCouncil = { ...APIHelper(PROJECT_COUNCIL_API) }
export const ResearchTopic = { ...APIHelper(RESEARCH_TOPIC_API) }
export const ResearchCouncil = { ...APIHelper(RESEARCH_COUNCIL_API) }

export const OrderCheckApi = {
  ...APIHelper(ORDER_CHECK_API),
}
export const ToolApi = {
  ...APIHelper(TOOL_API),
  reportLostBook: (id, data) => axios.put(`/order-tools/lost-tool/${id}`, { ...data }),
}

export const AcademicPeriod = {
  ...APIHelper(ACADEMIC_PERIOD_API),
}

// CRM

export const Lead = {
  ...APIHelper(LEAD_API),
  createManyLead: (leads) => {
    return axios.post(`/createMany`, { leads })
  },
}

export const LeadProgress = {
  ...APIHelper(LEAD_PROGRESS_API),
}

export const LeadLog = {
  ...APIHelper(LEAD_LOG_API),
}
export const Appointment = {
  ...APIHelper(APPOINTMENT_API),
}
export const SaleProduct = {
  ...APIHelper(SALE_PRODUCT_API),
}
export const ProductType = {
  ...APIHelper(PRODUCT_TYPE_API),
}
export const CountStatus = {
  ...APIHelper(STATUS_COUNT),
}
export const CountSucceed = {
  ...APIHelper(SUCCEED_COUNT),
}
export const TuitionFeeClassSettings = {
  ...APIHelper(TUITION_FEE_CLASS_SETTINGS_API),
}
export default {
  Auth,
  Bus,
  BusStop,
  Class,
  Attendance,
  Slot,
  DraftSlot,
  Log,
  Student,
  SchoolYear,
  Major,
  User,
  UserMeta,
  Mark,
  Facility,
  Lead,
  Staff,
  Transcript,
  Room,
  Book,
  Semester,
  Division,
  Grade,
  Subject,
  Violation,
  Factor,
  Post,
  SubjectGroup,
  ContactBook,
  Sms,
  History,
  AcademicLevel,
  Diligence,
  Checkin,
  Teaching,
  TeacherCat,
  TeacherDoc,
  Message,
  MessageGroup,
  DocumentType,
  Document,
  ClassNote,
  Dish,
  Menu,
  StudentMenu,
  MealTransfer,
  TuitionFeeGroup,
  TuitionFeeHeadFee,
  TuitionFeeGroupStudent,
  TuitionFeeGroupHeadFee,
  TuitionFeePrice,
  tuitionFeePriceStudent,
  TuitionFeePeriod,
  BankAccount,
  TuitionFeeReport,
  TuitionFeeCollection,
  TaskProgress,
  Task,
  StudentTracking,
  BusStudent,
  BusSchedules,
  SchoolSettings,
  SalaryPeriod,
  SalaryCollection,
  SalaryGroup,
  SalaryGroupHead,
  SalaryGroupTeacher,
  SalaryHead,
  SalaryPrice,
  SalaryPriceTeacher,
  SalaryReport,
  SbsentRequest,
  StudentCreditApi,
  StudentCreditUsageApi,
  Exam,
  SubjectExam,
  SubjectExamGroup,
  DocCategory,
  GradeDocument,
  Lesson,
  ExamRoom,
  ExamMark,
  LessonAttendance,
  RoomSubject,
  MonitorExam,
  GradeReview,
  Classroom,
  Category,
  BookApi,
  ProjectTopic,
  ProjectWish,
  ProjectCouncil,
  GradeMarkApi,
  GradeClassMarkApi,
  GradeClassMarkStudentApi,
  OrderApi,
  OrderCheckApi,
  ToolApi,
  ResearchTopic,
  ResearchCouncil,
  AcademicPeriod,
  Evaluate,
  EvaluateCriteria,
  EvaluateStudent,
  EvaluateTemplate,
  Department,
  // CRM
  LeadProgress,
  LeadLog,
  Appointment,
  SaleProduct,
  ProductType,
  CountStatus,
  CountSucceed,
  TuitionFeeClassSettings,
}
